"use strict";
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.cleanVal = exports.filterData = exports.sortData = exports.getPageEntries = void 0;
function getPageEntries(data, page, rows, visibleFields, sortOrder, sortField, filterValue) {
    var entries = undefined;
    var sorted = undefined;
    var filtered = undefined;
    var position = typeof page === 'string' ? page.charCodeAt(0) - 97 + 1 : page;
    var first = position * rows - rows;
    var last = first + rows;
    if (sortOrder && sortField) {
        sorted = sortData(data, sortOrder, sortField);
    }
    if (filterValue) {
        filtered = sorted ? filterData(sorted, filterValue, visibleFields) : filterData(data, filterValue, visibleFields);
    }
    if (filtered) {
        entries = filtered.slice(first, last);
    }
    else if (sorted) {
        entries = sorted.slice(first, last);
    }
    else {
        entries = data.slice(first, last);
    }
    return entries || data;
}
exports.getPageEntries = getPageEntries;
function sortData(data, sortOrder, sortField) {
    var clone = __spreadArrays(data);
    var sorted;
    if (typeof sortOrder === 'number') {
        sorted = clone.sort(function (a, b) {
            var valA = cleanVal(a[sortField]);
            var valB = cleanVal(b[sortField]);
            if (valA > valB) {
                return sortOrder;
            }
            else {
                return sortOrder * -1;
            }
        });
    }
    return sorted;
}
exports.sortData = sortData;
function filterData(data, filterValue, visibleFields) {
    var clone = __spreadArrays(data);
    var query = cleanVal(filterValue);
    var filtered = clone.filter(function (entry) {
        var keys = Object.keys(entry);
        return keys.find(function (key) {
            var type = typeof entry[key];
            if (visibleFields.includes(key)) {
                switch (type) {
                    case 'string':
                        return entry[key].toLowerCase().includes(query);
                    case 'number':
                        return entry[key] === parseInt(filterValue, 10);
                    default:
                        return false;
                }
            }
        });
    });
    return filtered;
}
exports.filterData = filterData;
function cleanVal(input) {
    var value = input;
    if (typeof value === 'string') {
        value = value.toLowerCase();
    }
    return value;
}
exports.cleanVal = cleanVal;
//# sourceMappingURL=paginationHelper.js.map